import React, {useEffect} from 'react';
import { useWidgetScorecardData } from "../data/DataHooks";
import { isSameScorecard, isSameMajor } from "../Helpers.js";
import Scorecard from './Scorecard';
import ScorecardPlaceholder from './ScorecardPlaceholder';

const InlineScorecard = ( { source, data, children } ) => {

  let { unitid, cipCode, degreeLevel } = data;
  let { scorecard, majors } = useWidgetScorecardData( source, unitid, cipCode, degreeLevel );

  return (
    <div className="inline-scorecard">
      { children }

        {scorecard && (
          <Scorecard decorated={false} scorecard={ scorecard } majors={ majors }>
          </Scorecard>
        )}

        {!scorecard && (
          <ScorecardPlaceholder>
          </ScorecardPlaceholder>
        )}

    </div>
  );
}


export default InlineScorecard;
